module.exports = __webpack_public_path__ + "static/media/esim_graph1_en.d1d8cb59.png";